const PRODUCT_SEARCH_PARAMS = [
  'ProductCategories',
  'CatheterTypes',
  'CatheterLengths',
  'CatheterSizes',
  'CatheterBrands',
  'CatheterOptions',
  'CatheterAccessories',
  'OstomySurgeryTypes',
  'OstomyProductTypes',
  'OstomyProductFeatures',
  'OstomyProductBrands',
  'Page',
  'PageSize',
  'SearchTerm',
] as const

export type ProductSearchQuery = Partial<Record<(typeof PRODUCT_SEARCH_PARAMS)[number], string>>

function toValue(raw: unknown): string | undefined {
  if (typeof raw === 'string')
    return raw
  if (Array.isArray(raw))
    return raw.filter(value => typeof value === 'string').join(',')
  return undefined
}

export function pickProductSearchQuery(query: Record<string, unknown>): ProductSearchQuery {
  const values = new Map<string, string>()
  for (const [key, raw] of Object.entries(query)) {
    const value = toValue(raw)
    if (value)
      values.set(key.toLowerCase(), value)
  }

  const picked: ProductSearchQuery = {}
  for (const param of PRODUCT_SEARCH_PARAMS) {
    const value = values.get(param.toLowerCase())
    if (value)
      picked[param] = value
  }
  return picked
}
